import { createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { lazyPage } from '@/lib/lazy-page'
import { canvasRoute } from './canvas-route'

export const AllDrawingsPage = lazyPage(() => import('./features/drawings/drawings-page.lazy'), 'AllDrawingsPage')
export const SharedDrawingsPage = lazyPage(() => import('./features/drawings/drawings-page.lazy'), 'SharedDrawingsPage')
export const TrashDrawingsPage = lazyPage(() => import('./features/drawings/drawings-page.lazy'), 'TrashDrawingsPage')
export const CollectionDrawingsPage = lazyPage(
  () => import('./features/drawings/drawings-page.lazy'),
  'CollectionDrawingsPage',
)
export const RedeemPage = lazyPage(() => import('./features/sharing/redeem-link-page.lazy'), 'RedeemPage')
export const CanvasEditorPage = lazyPage(() => import('./features/editor/editor-page.lazy'), 'CanvasEditorPage')

export const canvasAllRoute = createRoute({
  getParentRoute: () => canvasRoute,
  path: '/',
  component: AllDrawingsPage,
})

export const canvasSharedRoute = createRoute({
  getParentRoute: () => canvasRoute,
  path: 'shared',
  component: SharedDrawingsPage,
})

export const canvasTrashRoute = createRoute({
  getParentRoute: () => canvasRoute,
  path: 'trash',
  component: TrashDrawingsPage,
})

export const canvasCollectionRoute = createRoute({
  getParentRoute: () => canvasRoute,
  path: 'collections/$collectionId',
  component: CollectionDrawingsPage,
})

export const canvasRedeemRoute = createRoute({
  getParentRoute: () => canvasRoute,
  path: 'redeem/$drawingId',
  validateSearch: (search: Record<string, unknown>): { share?: string } =>
    typeof search.share === 'string' ? { share: search.share } : {},
  component: RedeemPage,
})

export const canvasEditorRoute = createRoute({
  getParentRoute: () => entityRoute,
  path: 'canvas/d/$drawingId',
  component: CanvasEditorPage,
})
